import toast from "react-hot-toast";
export const notif = (message: string = "", type: string = "default") => {
  const iconMap = {
    default: "✨",
    success: "✔️",
    error: "❌",
    warning: "⚠️",
    info: "📖",
  };
  toast(message, {
    icon: iconMap[type as keyof typeof iconMap],
    style: {
      borderRadius: "10px",
      background: "#333",
      color: "#fff",
    },
  });
};
